module.exports = __webpack_public_path__ + "assets/img/1eda40fcbbabc43e560d440b9f487c67.svg";